module.exports = __webpack_public_path__ + "img/processing-03.60186d9c.svg";